module.exports = __webpack_public_path__ + "static/blue-shape-64783e708003208c4fae1abf05c7ad04.png";